// resources/js/ui/header/index.js
import headerMenu from './header-menu';
import sidebarMenu from './sidebar-menu';

function mountHeaderUI() {
  // Standaard selectors; pas via options aan indien nodig
  headerMenu();      // .wk-hamburger → #wk-header-panel + #wk-header-overlay
  sidebarMenu();     // #menu-toggle → #wk-sidebar + #wk-sidebar-overlay
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountHeaderUI, { once: true });
} else {
  mountHeaderUI();
}

export default mountHeaderUI;
